import { render, staticRenderFns } from "./AppApi.vue?vue&type=template&id=4f8f8094&"
import script from "./AppApi.vue?vue&type=script&lang=js&"
export * from "./AppApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports